module.exports = __webpack_public_path__ + "img/bottle.530c1d36.png";